import { Component, Input, OnInit } from '@angular/core';
import { Ech0134grundbuchmeldungService } from '../../../core/grundbuchmeldung-api';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DeleteCheckModalComponent } from '../../../shared/components/modals/delete-check-modal/delete-check-modal.component';
import { GrundbuchgeschaeftRestDetailEntryMeta } from '../../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Ech0134ModuleService } from '../../ech0134-module.service';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'cap-ech0134-grundbuchmeldung-delete-button',
  templateUrl: './ech0134-grundbuchmeldung-delete-button.component.html',
  styleUrls: ['./ech0134-grundbuchmeldung-delete-button.component.scss'],
  imports: [NgbTooltip, TranslatePipe]
})
export class Ech0134GrundbuchmeldungDeleteButtonComponent implements OnInit {
  @Input()
  private geschaeft: GrundbuchgeschaeftRestDetailEntryMeta;
  disabled: boolean;

  constructor(
    private backend: Ech0134grundbuchmeldungService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private moduleService: Ech0134ModuleService,
    private appPermissionService: AppPermissionService
  ) {}

  ngOnInit() {
    this.disabled = !this.appPermissionService.hasPermission('ECH_0134_VERWALTEN_MELDUNG');
  }

  onDelete() {
    const modal = this.modalService.open(DeleteCheckModalComponent);
    modal.componentInstance.entity = this.translateService.instant('ech0134.grundbuchmeldungen.title');
    modal.result.then(
      () => {
        lastValueFrom(this.backend.deleteMeldungByGeschaeft(this.geschaeft.id.id)).then(() => {
          this.moduleService.onDelete();
          this.geschaeft.eCH0134GeneriertAm = null;
        });
      },
      () => {
        // cancel
      }
    );
  }
}
